import { Component, EventEmitter, OnInit, DoCheck, Output } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { CalculationService } from '../services/calculation.service';
import { FormDataService } from '../services/form-data.service';
import { CurrencyService } from '../services/currency.service';

@Component({
  selector: 'app-main-input-form',
  templateUrl: './main-input-form.component.html',
  styleUrls: ['./main-input-form.component.scss'],
  providers: [FormBuilder],
  standalone: false
})
export class MainInputFormComponent implements OnInit, DoCheck {
  @Output('changeData') sendTheNewDataJSON = new EventEmitter<any>();
  @Output('isEverythingCorrect') isEverythingCorrect = new EventEmitter<any>();
  @Output() hidePackages = new EventEmitter();
  @Output() initManPrem = new EventEmitter();

  // private bornDate: string = "";
  private previousBornDate: string;
  // private years: number;
  private previousYears: number;
  // private amoutOfMoney: number;
  private previousAmoutOfMoney: number;
  doubleVisualization: boolean = true;
  private currency: string; // "BGN" or "EUR"
  private bgCurrency: string;
  public isCurrencyBGN: boolean = true;
  private isPreviousCurrencyBGN: boolean = true;
  public isCurrencyEUR: boolean = false;
  private isPreviousCurrencyEUR: boolean = false;
  private selectedPaymentType: number; // "1" / "12"
  public isPaymentPerMonthSelected: boolean = true;
  private isPreviousPaymentPerMonth: boolean = true;
  public isPaymentPerYearSelected: boolean = false;
  private isPreviousPaymentPerYear: boolean = false;
  public isDateCorrect: boolean = true;
  private currentDate: Date;
  public inputClick: boolean = false;
  private returnedData: any = [];
  private bornDate: string;
  private years: number;
  private amoutOfMoney: number;
  private manPrem: number;
  public yearsOfDuration65: boolean = false;

  // variables that show or hide some message on the screen
  public isThereEmptyField: boolean = false;
  public isBornDateCharactersCorrect: boolean = true;
  public isBornDateMonthAndDayCorrect: boolean = true;
  public isBornDateLengthCorrect: boolean = true;
  public isSumEnough: boolean = true;
  public isBornDateCorrect: boolean = true;
  public isYearsOfDurationCorrect: boolean = true;
  public state: boolean = false;

  mainInputFormGroup = new FormGroup({
    dateOfBorn: new FormControl(null, Validators.compose([Validators.pattern(new RegExp(/^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/)), Validators.required, Validators.minLength(10), Validators.maxLength(10), this.ageValidator])),
    yearsOfDuration: new FormControl(null, Validators.compose([Validators.pattern(new RegExp(/^[0-9]+$/)), Validators.required, Validators.min(10), Validators.max(30)])),
    amoutOfMoney: new FormControl()
  });

  constructor(public formBuilder: FormBuilder, private calculationService: CalculationService, private data: FormDataService, private currencyService: CurrencyService) { }

  ngOnInit() {
    this.data.currentState.subscribe(state => {
      this.state = state;
    });

    if(this.currencyService.getMainEuro()){
      this.changeCurrencyToEUR();
      this.doubleVisualization = false;
    }


  }

  ageValidator(control: FormControl) {

    return {};
  }

  ngDoCheck() {
    
    this.currentDate = new Date();

    if ((this.mainInputFormGroup.controls['dateOfBorn'].value != this.previousBornDate) ||
      (this.mainInputFormGroup.controls['yearsOfDuration'].value != this.previousYears) ||
      (this.mainInputFormGroup.controls['amoutOfMoney'].value != this.previousAmoutOfMoney) ||
      (this.doubleVisualization && (this.isCurrencyBGN != this.isPreviousCurrencyBGN)) ||
      (this.doubleVisualization && (this.isCurrencyEUR != this.isPreviousCurrencyEUR)) ||
      (this.isPaymentPerMonthSelected != this.isPreviousPaymentPerMonth) ||
      (this.isPaymentPerYearSelected != this.isPreviousPaymentPerYear)) {

      if (this.isPaymentPerMonthSelected) {
        if (this.isCurrencyBGN) {
          this.currency = "BGN";
          this.bgCurrency = "ЛВ";
        }
        else if (this.isCurrencyEUR) {
          this.currency = "EUR";
          this.bgCurrency = "ЕВРО";
        }
        this.selectedPaymentType = 12;
      }
      else if (this.isPaymentPerYearSelected) {
        if (this.isCurrencyBGN) {
          this.currency = "BGN";
          this.bgCurrency = "ЛВ";
        }
        else if (this.isCurrencyEUR) {
          this.currency = "EUR";
          this.bgCurrency = "ЕВРО";
        }
        this.selectedPaymentType = 1;
      }

      let date = new String(this.mainInputFormGroup.controls['dateOfBorn'].value).toString().split(".");
      let bornDate = null;
      if ((date[0] != null && date[0] != undefined && date[0] != "") &&
        (date[1] != null && date[1] != undefined && date[1] != "") &&
        (date[2] != null && date[2] != undefined && date[2] != "")) {
        if (new String(date[2]).length == 4) {
          bornDate = date[2] + "-" + date[1] + "-" + date[0];

          let ageAfterYears = this.getAgeAfterYears(bornDate, parseInt(this.mainInputFormGroup.controls['yearsOfDuration'].value));
          let ageToday = this.getAgeAfterYears(bornDate, 0);

          if (ageAfterYears >= 65  && ageAfterYears <= 70 ) {
            this.hidePackagesChange(true);
          } else {
            this.hidePackagesChange(false);
          }
          if ( ageToday > 60 || ageAfterYears > 70) {
            // this.changePrem(false);
            this.isDateCorrect = false;
          } else {
            // this.changePrem(true);
            this.isDateCorrect = true;
          }
        }
      }

      let dataJSON = {
        bornDate: bornDate,
        years: this.mainInputFormGroup.controls['yearsOfDuration'].value * 1,
        amoutOfMoney: Math.round(this.mainInputFormGroup.controls['amoutOfMoney'].value * 1),
        currency: this.currency,
        selectedPaymentType: this.selectedPaymentType * 1
      }
      
      this.bornDate = dataJSON.bornDate;
      this.years = dataJSON.years;
      this.amoutOfMoney = dataJSON.amoutOfMoney;
      
      this.changeData(dataJSON);
      this.previousBornDate = this.mainInputFormGroup.controls['dateOfBorn'].value;
      this.previousYears = this.mainInputFormGroup.controls['yearsOfDuration'].value;
      this.previousAmoutOfMoney = this.mainInputFormGroup.controls['amoutOfMoney'].value;
      this.isPreviousCurrencyBGN = this.isCurrencyBGN;
      this.isPreviousCurrencyEUR = this.isCurrencyEUR;
      this.isPreviousPaymentPerMonth = this.isPaymentPerMonthSelected;
      this.isPreviousPaymentPerYear = this.isPaymentPerYearSelected;
      
      this.calculate();
    }
    if(this.state) {
      this.mainInputFormGroup.patchValue({
        yearsOfDuration: '',
        amoutOfMoney: ''
      });
      this.data.changeState(false);
    }
  }

  changeData(newDataJSON: any) {
    this.sendTheNewDataJSON.emit(newDataJSON);
  }

  hidePackagesChange(value: boolean) { // You can give any function name
    this.hidePackages.emit(value);
  }

  changeCurrencyToBGN() {
    this.isCurrencyBGN = true;
    this.isCurrencyEUR = false;
  }

  changeCurrencyToEUR() {
    this.isCurrencyBGN = false;
    this.isCurrencyEUR = true;
  }

  changePaymentPerMonth() {
    this.isPaymentPerMonthSelected = true;
    this.isPaymentPerYearSelected = false;
  }

  changePaymentPerYear() {
    this.isPaymentPerMonthSelected = false;
    this.isPaymentPerYearSelected = true;
  }

  changePrem(isEverythingCorrect: any) {
    this.isEverythingCorrect.emit(isEverythingCorrect);
  }

calculate() {
  this.returnedData = [];

  // Validation - check are all inputs correct
  this.isThereEmptyField = false;
  this.isBornDateCharactersCorrect = true;
  this.isBornDateMonthAndDayCorrect = true;
  this.isBornDateLengthCorrect = true;
  this.isSumEnough = true;
  this.isBornDateCorrect = true;
  this.isYearsOfDurationCorrect = true;

  if (!this.bornDate || !this.years || !this.amoutOfMoney || !this.selectedPaymentType) {
    this.isThereEmptyField = true;
    this.changePrem(false);
  }
  else {
    this.isThereEmptyField = false;

    if (new RegExp(/^[0-9\-]+$/).test(this.bornDate)) {
      this.isBornDateCharactersCorrect = true;

      const dateParts = this.bornDate.split("-");
      const month = parseInt(dateParts[1], 10);
      const day = parseInt(dateParts[2], 10);
      
      if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
        this.isBornDateMonthAndDayCorrect = true;

        if (new String(this.bornDate).toString().length === 10) {
          this.isBornDateLengthCorrect = true;

          let userYears = new Date().getFullYear() - new Date(this.bornDate).getFullYear();

          if (userYears >= 14 && userYears <= 60) {
            this.isBornDateCorrect = true;

            if ((userYears + this.years) <= 70) {
              this.isBornDateCorrect = true;

              if (this.years >= 10 && this.years <= 30) {
                this.isYearsOfDurationCorrect = true;

                // send the data to the service
                this.calculationService.sendDataForCalculation(
                  'N', // при включени тежки заболявания - "Y" or "N"
                  'N', // при включено второ медицинско мнение - - "Y" or "N"
                  this.bornDate,
                  this.years,
                  this.amoutOfMoney,
                  this.currency,
                  this.selectedPaymentType,
                  'N', //  'Y' -> Включено СМЪРТ ОТ ЗЛОПОЛУКА, 'N' -> Без СМЪРТ ОТ ЗЛОПОЛУКА
                  0, //  0 -> Без БОЛНИЧЕН ПРЕСТОЙ, 1 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА, 2 -> Включен БОЛНИЧЕН ПРЕСТОЙ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                  0, //  0 -> Без РАЗХОДИ ЗА ЛЕКАРСТВА, 1 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА, 2 -> Включен РАЗХОДИ ЗА ЛЕКАРСТВА ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                  0, // 0 -> Без ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ,   1 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включена ВРЕМЕННА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                  0 //0 -> Без ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ, 1 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА, 2 -> Включен ТРАЙНА ЗАГУБА НА ТРУДОСПОСОБНОСТ ОТ ЗЛОПОЛУКА ИЛИ ЗАБОЛЯВАНЕ
                ).subscribe(
                  resultData => {
                    this.returnedData.push(resultData);

                    this.manPrem = this.returnedData[0].payload.CalcPrem[0].PREMIUM;

                    this.initManPrem.emit(this.manPrem);

                    if(this.isPaymentPerMonthSelected){
                      if(this.isCurrencyBGN){
                        if(this.manPrem < 25){
                          this.isSumEnough = false;
                        }
                      }
                      if(this.isCurrencyEUR){
                        if(this.manPrem < 12.5){
                          this.isSumEnough = false;
                        }
                      }
                    }
                    if(this.isPaymentPerYearSelected){
                      if(this.isCurrencyBGN){
                        if(this.manPrem < 300){
                          this.isSumEnough = false;
                        }
                      }
                      if(this.isCurrencyEUR){
                        if(this.manPrem < 150){
                          this.isSumEnough = false;
                        }
                      }
                    }
                    if (!this.isThereEmptyField && this.isBornDateCharactersCorrect && this.isBornDateMonthAndDayCorrect && this.isBornDateLengthCorrect && this.isSumEnough && this.isYearsOfDurationCorrect) {
                      this.changePrem(true);
                    } else {
                      this.changePrem(false);
                    }
                  },
                  err => {
                    console.log("Error has occured: ", err);
                  }
                  );
              }
              else {
                this.isYearsOfDurationCorrect = false;
                this.changePrem(false);
              }
            }
            else {
              this.isBornDateCorrect = false;
              this.changePrem(false);
            }
          }
          else {
            this.isBornDateCorrect = false;
            this.changePrem(false);
          }
        }
        else {
          this.isBornDateLengthCorrect = false;
          this.changePrem(false);
        }
      }
      else {
        this.isBornDateMonthAndDayCorrect = false;
        this.changePrem(false);
      }
    }
    else {
      this.isBornDateCharactersCorrect = false;
      this.changePrem(false);
    }
  }

}

getAgeAfterYears(birthDate: string, numberOfYearsAfter: number){

  let ageYears: number = 0;

  let now = new Date();
  let today = new Date(now.getFullYear(),now.getMonth(),now.getDate());
  let dateOfBirth = new Date( parseInt(birthDate.split('-')[0]), parseInt(birthDate.split('-')[1])-1, parseInt(birthDate.split('-')[2]));

  let yearOfBirth = dateOfBirth.getFullYear();
  let monthOfBirth = dateOfBirth.getMonth();
  let dayOfBirth = dateOfBirth.getDate();

  let yearAfterYears = today.getFullYear() + numberOfYearsAfter;
  let monthAfterYears = today.getMonth();
  let dayAfterYears = today.getDate(); 

  ageYears = yearAfterYears - yearOfBirth;

  if( (monthAfterYears < monthOfBirth) || ( (monthAfterYears == monthOfBirth) && (dayAfterYears < dayOfBirth) ) )
    ageYears--;

  return ageYears;
}

}
